import type { PropType } from 'vue';
import { defineComponent, h, computed } from 'vue';

import type { Contract, Depot } from '@/api/contracts/types';
import GridTable, { type GridTableItem } from '@/application/components/GridTable.vue';
import Coinsured from '@/contracts/components/Coinsured.vue';
import ContractStatus from '@/contracts/components/ContractStatus.vue';
import { formatDecimal } from '@/application/utils/money';

export default defineComponent({
  name: 'DepotDetailsTable',
  props: {
    depot: {
      type: Object as PropType<Depot>,
      required: true,
    },
    contract: {
      type: Object as PropType<Contract>,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const items = computed<GridTableItem[]>(() => [
      {
        title: 'Vertragsnummer',
        value: h('b', props.contract?.number || ''),
      },
      {
        title: 'Status',
        value: h(ContractStatus, { status: props.depot.status }),
      },
      {
        title: 'Monatliche Sparrate',
        value: props.depot.monthly_payment_rate
          ? h('b', formatDecimal(props.depot.monthly_payment_rate))
          : null,
      },
      {
        title: 'Depotwert',
        value: formatDecimal(props.depot.depot_evaluation),
      },
      {
        title: 'Mitversicherte Personen',
        value: props.contract?.coinsured.length
          ? h(Coinsured, { coinsuredPersons: props.contract.coinsured })
          : null,
      },
    ]);

    return () => h(GridTable, { items: items.value, mutedTitle: true, rightAlignedValue: true });
  },
});
